import { FieldNodeType } from '@modusign/react-signing/types';
import React from 'react';

import {
  RenderableSignerFieldNodeType,
  RequesterFieldNodeType,
} from '@app/features/apply-react-signing/components/FieldRenderer/fieldTypes';
import AutofillFieldGroupRenderer from '@app/features/apply-react-signing/components/FieldRenderer/Setup/FieldRenderers/AutofillFieldGroupRenderer';
import ConfigurableCheckboxGroupFieldRenderer from '@app/features/apply-react-signing/components/FieldRenderer/Setup/FieldRenderers/ConfigurableCheckboxGroupFieldRenderer';
import { ConfigurableDateFieldRenderer } from '@app/features/apply-react-signing/components/FieldRenderer/Setup/FieldRenderers/ConfigurableDateField';
import { ConfigurableSignatureFieldRenderer } from '@app/features/apply-react-signing/components/FieldRenderer/Setup/FieldRenderers/ConfigurableSignatureFieldRenderer';
import { ConfigurableSigningDateFieldRenderer } from '@app/features/apply-react-signing/components/FieldRenderer/Setup/FieldRenderers/ConfigurableSigningDateField';
import { ConfigurableTextFieldRenderer } from '@app/features/apply-react-signing/components/FieldRenderer/Setup/FieldRenderers/ConfigurableTextFieldRenderer';
import { ConfigurableDropdownFieldRenderer } from '@app/features/apply-react-signing/components/FieldRenderer/Setup/FieldRenderers/ConfiguralbeDropdownField';
import RequesterCheckboxFieldRenderer from '@app/features/apply-react-signing/components/FieldRenderer/Setup/FieldRenderers/RequesterCheckboxFieldRenderer';
import RequesterImageFieldRenderer from '@app/features/apply-react-signing/components/FieldRenderer/Setup/FieldRenderers/RequesterImageFieldRenderer';
import RequesterTextFieldRenderer from '@app/features/apply-react-signing/components/FieldRenderer/Setup/FieldRenderers/RequesterTextFieldRenderer';
import { ReactSigningFieldRendererProps } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import { withFieldRendererMemo } from '@app/features/apply-react-signing/libs/hooks/useCollectionOptimal';

export type FieldComponent = React.FunctionComponent<ReactSigningFieldRendererProps>;
type ComponentByType<T extends FieldNodeType> = { [K in T]: FieldComponent | null };

type SignerFieldNodeComponentByType = ComponentByType<RenderableSignerFieldNodeType>;

export const SignerFieldComponentByFieldNodeType: SignerFieldNodeComponentByType = {
  SIGNATURE: withFieldRendererMemo(ConfigurableSignatureFieldRenderer),
  CHECKBOX_GROUP: withFieldRendererMemo(ConfigurableCheckboxGroupFieldRenderer),
  TEXT: withFieldRendererMemo(ConfigurableTextFieldRenderer),
  DROPDOWN: withFieldRendererMemo(ConfigurableDropdownFieldRenderer),
  // TODO: @DevSDK 구현
  DATE: withFieldRendererMemo(ConfigurableDateFieldRenderer),
  SIGNING_DATE: withFieldRendererMemo(ConfigurableSigningDateFieldRenderer),
  AUTOFILL_GROUP: withFieldRendererMemo(AutofillFieldGroupRenderer),
};

export type RequesterFieldComponentByType = ComponentByType<RequesterFieldNodeType>;

export const RequesterFieldComponentByFieldNodeType: RequesterFieldComponentByType = {
  CHECKBOX: withFieldRendererMemo(RequesterCheckboxFieldRenderer),
  TEXT: withFieldRendererMemo(RequesterTextFieldRenderer),
  IMAGE: withFieldRendererMemo(RequesterImageFieldRenderer),
};
